import Vue from 'vue'
import locale from 'element-ui/lib/locale'
import VueI18n from 'vue-i18n'
import messages from './lang'
import LangStorage from './lang/index'

Vue.use(VueI18n)
const i18n = new VueI18n({
  // locale: localStorage.lang || 'cn',
  locale: LangStorage.getLang('cn'),//调用lang.js的getLang()方法获取语言
  messages
})
locale.i18n((key, value) => i18n.t(key, value)) //重点：为了实现element插件的多语言切换


export default i18n